<template >
  <div v-loading="loading" >
    <el-card v-if="$route.name == 'package_services'" >
      <div
          slot="header"
          class="clearfix" >
        <s-form-actions v-if="ScheduleTrip" >
          <h4
              slot="left"
              v-if="Customer" >
            <el-button
                style="float: left"
                type="text"
                plain
                title="stop doing that"
                @click="routeGo({ query: { selected_customer: null } })" >
              <i
                  class="material-icons"
                  style="font-size: 12px" >remove_circle_outline</i >
            </el-button >
            {{ Customer.leader }}
            <small >add/remove from services</small >
          </h4 >
          <el-col :md="24" >
            <el-row :gutter="10" >
              <el-col
                  :xs="24"
                  :md="16" >
                <s-remote-select
                    dark
                    title="Suggested sapplier servise"
                    placeholder="select new activity"
                    v-model="add_product_id"
                    class-model="pricerules"
                    query-prop="q"
                    label-prop="name"
                    :extraQueryParams="{ mode: 'select', context: 'sapplier' }"
                    :automatic-dropdown="true" >
                  <!-- <template slot-scope="{item}">
                  {{item.name}}
                  <el-tag type="info">{{item.loc_name}}</el-tag>
                  </template>-->
                </s-remote-select >
              </el-col >
              <el-col
                  :xs="4"
                  :md="4" >
                <s-button
                    type="success"
                    :disabled="!add_product_id"
                    @execute="addActivity" >
                  <i class="material-icons" >add</i >
                </s-button >
              </el-col >
              <el-col
                  :xs="4"
                  :md="4" >
                <s-button
                    type="danger"
                    :disabled="!!add_product_id"
                    confirm="this action will recover any default servise that have been removed"
                    @execute="recoverDefaults" >
                  <i class="material-icons" >settings_backup_restore</i >
                </s-button >
              </el-col >
            </el-row >
          </el-col >
          <!-- <el-col :md="6">

            <el-button
              style="float:right"
              v-if="Customer"
              type="warning"
              plain
              title="click to stop working selected customer"
              @click="Customer=null;$router.push({name: 'package_services',params:$route.params})"
            >
              <small>handle:</small>
              {{Customer.leader}}
              <i
                class="material-icons"
                style="font-size:12px"
              >remove_circle_outline</i>
            </el-button>
          </el-col>

          <el-col :md="12" title="Start date of package">

            <el-checkbox v-model="ScheduleTrip.delete_bookings" style="color:#ff0000;float:right">
              <fa icon="user-slash"></fa>
            </el-checkbox>
            <s-btn-delete type="danger" style="float:right" @go="deletePackagedTrip()"></s-btn-delete>
            <s-dater
              style="float:right"
              type="date"
              v-model="ScheduleTrip.time"
              @change="updateCommon('ScheduleTrip')"
            ></s-dater>
          </el-col>-->
        </s-form-actions >
      </div >
      <s-table
          ref="package_routes"
          defaultSort="in"
          :colDefinitions="tableCols"
          modx-processor="vue_route/getlist"
          :r-query="servicesQuery"
          :pagging="10000"
          :limit="10000"
          :lazyLoader="false"
          :addEmptyLine="false"
          @cell-change="updateRoute"
          @cell-clicked="clickHandler" ></s-table >
    </el-card >
  </div >
</template >

<script >
import * as api from "~/api/resource";

import {mapGetters, mapActions} from "vuex";
// import { async } from "q";
import commons from "~/mixins/commons";

export default {
  mixins: [commons],
  async mounted() {
    var vm = this;
    this.autoUpdate = ["workingTrip"]; //commons
    this.loading = false;
  },
  props: {
    viewmode: {
      type: String,
      default: "simple",
    },
  },
  watch: {},
  methods: {
    async clickHandler(val) {
      _log_("hell clickHandler", val.column.property);
      const vm = this;
      // isprivate
      if (val.column.property == "isprivate") {
        if (val.row.package_action_id.indexOf("p_") >= 0)
          val.row.package_action_id = val.row.package_action_id.replace(
              "p_",
              "c_"
          );
        else
          val.row.package_action_id = val.row.package_action_id.replace(
              "c_",
              "p_"
          );
        const r = await api.updateProcessor("vue_route/update", val.row);
        _log_("hell clickHandler r", r);
        return;
      }
      //package_action_id
      if (val.column.property == "package_action_id") {
        //package_services
        this.routeGo({
          name: "customers",
          ...this.$route.params,
          query: {selected_route: val.row.routename},
        });
        return;
      }
      //package_services
      if (val.column.property == "routename")
        if (vm.$route.query.selected_customer) {
          await api.updateProcessor("vue_route/updatebookings", {
            routename: val.row.routename,
            do:
                val.row.bookings.indexOf(
                    vm.$route.query.selected_customer + ""
                ) >= 0
                    ? "remove"
                    : "add",
            customer_id: vm.Customer ? vm.Customer.id : null,
          });
          if (val.row.id) this.$refs.package_routes.reloadRow(val.row.id);
          else this.$refs.package_routes.reload();
        }
        else if (val.column.property == "routename")
          this.$confirm("Are you sure?", "Warning", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "warning",
              })
              .then(async () => {
                await api.updateProcessor("vue_route/updatebookings", {
                  routename: val.row.routename,
                  do: "removeroute",
                });
                this.$refs.package_routes.reload();
                return;
              })
              .catch(() => {
              });
    },
    async addActivity() {
      const progress_msg = this.$message({
        message: "processing...",
        duration: 0,
      });
      const data = await api.updateProcessor("vue_route/addpackagedroute", {
        package_action_id: "c_" + this.uniqueKey(),
        tripid: this.$route.params.tripid,
        product: this.add_product_id,
        customer_id: this.Customer ? this.Customer.id : null,
      });
      this.$refs.package_routes.reload();
      progress_msg.close();
    },
    async recoverDefaults() {
      const progress_msg = this.$message({
        message: "processing...",
        duration: 0,
      });
      const data = await api.updateProcessor("vue_route/addpackagedroute", {
        tripid: this.$route.params.tripid,
        product: "defaults",
      });
      this.$refs.package_routes.reload();
      progress_msg.close();
    },
    async deletePackagedTrip() {
      this.loading = true;

      try {
        this.ScheduleTrip = await api.removeObject(
            "scheduletrip",
            this.ScheduleTrip
        );
      }
      catch (error) {
        _log_("error", error);
        this.$message.error("Oops, " + error.message);
        this.pocessing = false;
        return;
      }

      this.$emit("delete", this.ScheduleTrip);
      this.$emit("done", null);
      this.loading = false;
    },
    async updateRoute(val) {
      if (!val) return;
      if (val.row.package_action_id.indexOf("c_") < 0)
        val.row.package_action_id = val.row.package_action_id.replace(
            "p_",
            "c_"
        );
      _log_("go BEFORE q ", val.row.pupAid);
      const data = await api.updateProcessor("vue_route/update", val.row);
      _log_("go AFTER q ", data.pupAid);
      _log_("go sap q ", val.row, data);
      this.$refs.package_routes.updateRow(data);
    },
  },
  data() {
    return {
      add_product_id: null,
      loading: true,
      errors: {},
    };
  },
  computed: {
    servicesQuery() {
      _log_('this.$route.query', this.$route.params)
      const qPrts = {...this.$route.query}
      if (this.$route.params.tripid) {
        delete qPrts.timerange_from
        delete qPrts.timerange_to
      }
      let q = {
        ...this.$route.params,
        ...qPrts,
        createTransDrafts: true,
        mode: "packages",
      };

      return q;
    },
    tableCols() {
      const domain = window.Travel.wdb,
          vm = this;
      // _log_('is...', domain)
      var cols = [
        {
          prop: "serviseType",
          width: 50,
          label: "",
          // editorcomponent: {
          //   type: "date",
          //   displayFormat: "dd/MM/yyyy",
          //   is: "s-dater"
          // },
          // editable: true,
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);

            if (val == "ACCOMMODATION")
              return '<i class="material-icons">hotel</i>';
            if (val == "ACTIVITY")
              return '<i class="material-icons">directions_run</i>';
            return '<i class="material-icons">directions_bus</i>';
          },
        },
        {
          prop: "package_action_id",
          width: 50,
          label: "",
          action: "button",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);

            if (val.indexOf("c_") >= 0) {
              // if (row.bookings.length == 1)
              //   return (
              //     '<i title="' +
              //     val +
              //     ":" +
              //     row.routename +
              //     'this activity concerns only this customer " class="material-icons">person</i>'
              //   );
              if (row.bookings.length == 0) return "";
              return '<i title="this servise is custom, click to see who is in" style="color:orange" class="material-icons">card_giftcard</i>';
            }
            return '<i class="material-icons" title="this is a default serivise">card_travel</i>';
          },
        },
        {
          prop: "isprivate",
          width: 50,
          label: "",
          action: "button",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);

            if (row.package_action_id.indexOf("c_") >= 0) {
              return '<i title="this is a private servise, if you click it then it will be for all " class="material-icons">remove_circle</i>';
            }
            return '<i class="material-icons" title="this is for everybody, if you click it then it will be just for these ones ">people_outline</i>';
          },
        },
        {
          prop: "in",
          width: 150,
          label: "In",
          editorcomponent: {
            type: "date",
            displayFormat: "dd/MM/yyyy",
            is: "s-dater",
          },
          editable: true,
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatDate(val);
          },
        },

        {
          prop: "pupAid",
          width: "230px",
          label: "Out",
          editable: true,
          label: "Pick Up",
          editorcomponent: {
            is: "s-remote-select",
            classModel: "pup",
            queryProp: "q",
            labelProp: "name",
            valueProp: "id",
            extraQueryParams: {mode: "select"},
            filterable: true,
            clearable: true,
            multiple: false,
          },
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.serviseType != "ACCOMMODATION") return true;
            return false;
          },
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return row.pupnameA;
          },
        },
        {
          prop: "out",
          width: 150,
          label: "Out",
          editable: true,
          editorcomponent: {
            type: "date",
            displayFormat: "dd/MM/yyyy",
            is: "s-dater",
          },
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatDate(val);
          },
        },
        {
          prop: "pupZid",
          width: "230px",
          label: "Out",
          editable: true,
          label: "Drop Off",
          editorcomponent: {
            is: "s-remote-select",
            classModel: "pup",
            queryProp: "q",
            labelProp: "name",
            valueProp: "id",
            extraQueryParams: {mode: "select"},
            filterable: true,
            clearable: true,
            multiple: false,
          },
          editWhen(rowData) {
            // _log_('???E..',rowData)
            if (rowData.serviseType != "ACCOMMODATION") return true;
            return false;
          },
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return row.pupnameZ;
          },
        },
        // { prop: "pupnameZ", width: "230px", label: "End Point" },

        {
          prop: "details",
          width: "250px",
          label: "Servise",
          displayClass: "el-tag el-tag--info",
          editable: true,
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return row["serviseName"];
          },
          editorcomponent: {
            is: "s-remote-select",
            classModel: "pricerules",
            queryProp: "q",
            labelProp: "name",
            valueProp: "id",
            extraQueryParams: {mode: "select", context: "sapplier"},
            filterable: true,
            clearable: true,
            multiple: false,
          },
        },
        {prop: "pax", width: "90px", label: "Pax"},
      ];
      if (this.$route.query && this.$route.query.selected_customer)
        cols = [
          {
            prop: "routename",
            width: 50,
            label: "",
            action: "button",
            formatter: function (val, colDefs, row, vm) {
              // _log_(">>>>", vm.$route.query, row);

              // if (val.indexOf("c_") >= 0)
              //   if (row.singleBooking)
              //     return '<i class="material-icons">person</i>';
              //   else return '<i class="material-icons">supervisor_account</i>';
              if (
                  row.bookings.indexOf(vm.$route.query.selected_customer + "") >=
                  0
              )
                return '<i class="material-icons danger" title="click to remove this customer from this activity">indeterminate_check_box</i>';
              else
                return '<i class="material-icons"  title="click to add this customer to this activity">add_box</i>';
            },
          },
          ...cols,
        ];
      else
        cols = [
          {
            prop: "routename",
            width: 50,
            label: "",
            action: "button",
            formatter: function (val, colDefs, row, vm) {
              return '<i class="material-icons" style="color:red" title="add this customer to this activity">delete_forever</i>';
            },
          },
          ...cols,
        ];
      _log_("rent...", window.Travel.wdb);
      if (window.Travel.wdb == "travel_") cols.splice(9, 1);
      return cols;
    },
    datepickerOptions() {
      return {
        disabledDate: this.isBookable,
      };
    },
  },
};
</script >
